// extracted by mini-css-extract-plugin
export default {"lead":"OrderDetail_lead__vHXDJ","cardClass":"OrderDetail_cardClass__iF3cQ"};